import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import { useSearchParams } from "react-router-dom";
import ReadersRequestsView from "../../../../components/supervisor-requests/ReadersRequestsView";
import TutorsRequestsView from "../../../../components/supervisor-requests/TutorsRequestsView";

export default function RequestsPage() {
  const LocalBasePath = "page.supervisor.sessions";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [searchParams] = useSearchParams();

  const tabs = [
    {
      name: t("tutors"),
      content: <TutorsRequestsView />,
    },
    {
      name: t("students"),
      content: <ReadersRequestsView />,
    },
  ];

  return (
    <div className="w-full  flex flex-col gap-8  bg-gray-50 min-h-full">
      <div className="px-6 pt-6 ">
        <h2 className="text-gray-900 text-2xl font-semibold">
          {t("requests")}
        </h2>
      </div>
      <TabsComponent
        requests={true}
        defaultTab={+(searchParams.get("tab") ?? 0)}
        tabs={tabs}
      />
    </div>
  );
}
